import { FC, ReactNode } from "react";
import { PersonalChannelCoverContainer, PersonalChannelInfo } from "../styles";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { FInter } from "@brg/ui";

const DefaultMediaLabel = styled.div`
    color: #151514;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.34px;
`;

const TitleLabel = styled.div`
    div {
        font-family: Inter;
        font-size: 26px;
        font-style: normal;
        font-weight: 600;
        line-height: 32px;
        letter-spacing: -0.52px;
        color: #151514;
    }
`;

export const PersonalChannelCover: FC<{ 
    title: ReactNode, 
    cover: ReactNode 
}> = ({ title, cover})=> {
    const { t } = useTranslation();

    return (
        <PersonalChannelCoverContainer>
            <div style={{ width: '50%', position: 'relative'}}>
                {cover}
            </div>
            <PersonalChannelInfo gy={2} gyMobile={2}>
                <DefaultMediaLabel>{t('teams.adminPage.default_mediiia')}</DefaultMediaLabel>
                <TitleLabel>{title}</TitleLabel>
            </PersonalChannelInfo>
        </PersonalChannelCoverContainer>
    )
}import { FC, ReactNode } from "react";
import { PersonalChannelCoverContainer, PersonalChannelInfo } from "../styles";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { FInter } from "@brg/ui";

const DefaultMediaLabel = styled.div`
    color: #151514;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.34px;
`;

const TitleLabel = styled.div`
    div {
        font-family: Inter;
        font-size: 26px;
        font-style: normal;
        font-weight: 600;
        line-height: 32px;
        letter-spacing: -0.52px;
        color: #151514;
    }
`;

export const PersonalChannelCover: FC<{ 
    title: ReactNode, 
    cover: ReactNode 
}> = ({ title, cover})=> {
    const { t } = useTranslation();

    return (
        <PersonalChannelCoverContainer>
            <div style={{ width: '50%', position: 'relative'}}>
                {cover}
            </div>
            <PersonalChannelInfo gy={2} gyMobile={2}>
                <DefaultMediaLabel>{t('teams.adminPage.default_mediiia')}</DefaultMediaLabel>
                <TitleLabel>{title}</TitleLabel>
            </PersonalChannelInfo>
        </PersonalChannelCoverContainer>
    )
}